import { render, staticRenderFns } from "./CDotButton.vue?vue&type=template&id=d60ce67c&scoped=true"
import script from "./CDotButton.vue?vue&type=script&lang=js"
export * from "./CDotButton.vue?vue&type=script&lang=js"
import style0 from "./CDotButton.vue?vue&type=style&index=0&id=d60ce67c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60ce67c",
  null
  
)

export default component.exports